import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const getColorantPackageBarcode = (colorant, pckg) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.GET_COLORANT_PACKAGE_BARCODE,
        params: {
            colorant: colorant,
            package: pckg
        }
    },
    method: handlers.GET_BARCODE,
    tabId: 0
});

export const getColorantPackageBarcodeAndOpenModal = (colorant, pckg) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.GET_COLORANT_PACKAGE_BARCODE,
        params: {
            colorant: colorant,
            package: pckg
        }
    },
    method: handlers.GET_BARCODE_AND_OPEN_MODAL,
    tabId: 0,
    next: colorant
});

export const resetBarcode = () => ({
    type: actionTypes.BARCODE_RESET
});

export const saveBarcode = (barcode) => ({
    type: actionTypes.SAVE_BARCODE,
    payload: {
        barcode: barcode
    }
});

export const showManualScan = (show) => ({
    type: actionTypes.SHOW_MANUAL_SCAN,
    payload: {
        manualScan: show
    }
});
